import React from "react";
import Header from "./Header"; // ✅ adjust if your nav is named differently

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-black">
      {/* Fixed Navbar */}
      <header className="fixed top-0 left-0 w-full h-16 bg-black z-50 shadow-md">
        <Header />
      </header>

      {/* Page content (pushed down by nav height) */}
      <main className="flex-1 pt-16">{children}</main>
    </div>
  );
};

export default Layout;
